import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

export default function ProvisionTextContent(props) {
  const {
    data,
    index,
    lastIndex,
    organizer,
    title,
    onClickProvisionEditModal,
    onClickProvisonDeleteModal
  } = props;

  // 데이터 props 관련 변수 //
  const [id, setId] = useState(0);
  const [isDefault, setIsDefault] = useState(true);
  const [provisionTitle, setProvisionTitle] = useState('');
  const [provisionText, setProvisionText] = useState('');

  // 추가 약관 관련 수정/삭제 버튼호버링 변수 //
  const [isEditHover, setIsEditHover] = useState(false);
  const [isDeleteHover, setIsDeleteHover] = useState(false);


  // 데이터 분해 세팅 //
  useEffect(() => {
    setId(data.id);
    setIsDefault(data.isDefault);
    setProvisionTitle(data.title);
    setProvisionText(data.text);
  }, [data]);


  // Title 핸들링 함수 //
  function RenderTitleItem(props) {
    const { text } = props;

    if (text === "{organizer}") return <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#6DD49E' hover='default'>{organizer}</Text>
    else if (text === "{title}") return <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FF8B48' hover='default'>{title}</Text>
    else return <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' hover='default'>{text}</Text>
  };

  function renderTitleText(text) {
    const parts = text.split(/(\{title\}|\{organizer\})/g);

    return (
      <TextWrapper>
        {
          parts.map((data, index) => (
            <RenderTitleItem text={data} key={'Title-' + index} />
          ))
        }
      </TextWrapper>
    );
  };

  // Content 핸들링 함수 //
  function RenderContentItem(props) {
    const { text } = props;

    if (text === "{organizer}") return <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#6DD49E' hover='default'>{organizer}</Text>
    else if (text === "{title}") return <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FF8B48' hover='default'>{title}</Text>
    else return <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' hover='default'>{text}</Text>
  };

  function renderContentText(text) {
    const parts = text.split(/(\{title\}|\{organizer\})/g);

    return (
      <TextWrapper>
        {
          parts.map((data, index) => (
            <RenderContentItem text={data} key={'Content-' + index} />
          ))
        }
      </TextWrapper>
    );
  };


  // 높이 설정 //
  function decideHeight() {
    if (index < 16) return '100%';
    else return '97%';
  }


  // 수정하기 호버링 //
  function handleEditHover() {
    if (isEditHover === false) {
      setIsEditHover(true);
    }
    else {
      setIsEditHover(false);
    }
  };

  // 삭제하기 호버링 //
  function handleDeleteHover() {
    if (isDeleteHover === false) {
      setIsDeleteHover(true);
    }
    else {
      setIsDeleteHover(false);
    }
  };


  // 추가약관에 대한 수정/삭제 버튼에 호버링 시 상단선 변화 //
  function decideButtonBorderTop() {
    if (index < 16) return '2px solid #969696';
    else if (isEditHover) return '1px solid #6DD49E';
    else if (isDeleteHover) return '1px solid #FF3131';
    else return '1px solid #969696';
  };

  // 추가약관에 대한 수정/삭제 버튼에 호버링 시 사이드선 변화 //
  function decideButtonBorderSides() {
    if (index < 16) return '2px solid #969696';
    else if (isEditHover) return '2px solid #6DD49E';
    else if (isDeleteHover) return '2px solid #FF3131';
    else return '2px solid #969696';
  };

  // 추가약관에 대한 수정/삭제 버튼에 호버링 시 하단선 변화 //
  function decideButtonBorderBottom() {
    if (index === 15 && lastIndex === 15) return '2px solid #969696';
    else if (index > 15) {
      if (isEditHover) {
        if (index === lastIndex) return '2px solid #6DD49E';
        else return '1px solid #6DD49E';
      }
      else if (isDeleteHover) {
        if (index === lastIndex) return '2px solid #FF3131';
        else return '1px solid #FF3131';
      }
      else {
        if (index === lastIndex) return '2px solid #969696';
        else return '1px solid #969696';
      }
    }
  };

  // 추가약관에 대한 수정/삭제 버튼에 호버링 시 배경색 변화 //
  function decideButtonBackgrounColor() {
    if (isEditHover || isDeleteHover) return 'rgba(255, 255, 255, 0.10)';
  };


  // 추가 약관에 대한 수정/삭제 컴포넌트 추가 함수 //
  function renderButton() {
    return (
      <ButtonWrapper>
        <DivisionLine />
        <EditButton onClick={() => onClickProvisionEditModal(data)} onMouseEnter={handleEditHover} onMouseLeave={handleEditHover}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' hover='pointer'>수정하기</Text>
        </EditButton>
        <DivisionLine />
        <DeleteButton onClick={() => onClickProvisonDeleteModal(data)} onMouseEnter={handleDeleteHover} onMouseLeave={handleDeleteHover}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' hover='pointer'>삭제하기</Text>
        </DeleteButton>
      </ButtonWrapper>
    );
  };



  return (
    <TopLevelWrapper>
      <ContentWrapper
        height={decideHeight()}
        isFirst={index === 0}
        isLast={index === lastIndex}
        borderTop={decideButtonBorderTop()}
        borderSides={decideButtonBorderSides()}
        borderBottom={decideButtonBorderBottom()}
        backgroundColor={decideButtonBackgrounColor()}>
        <TitleTextWrapper>
          {renderTitleText(provisionTitle)}
        </TitleTextWrapper>
        <DivisionLine />
        <HistoryTextWrapper>
          {renderContentText(provisionText)}
        </HistoryTextWrapper>
        {!isDefault && renderButton()}
      </ContentWrapper>
    </TopLevelWrapper>
  );
};


const TopLevelWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: ${props => props.height};

  border-top-left-radius: ${props => props.isFirst ? '10px' : '0px'};
  border-top-right-radius: ${props => props.isFirst ? '10px' : '0px'};
  border-bottom-left-radius: ${props => props.isLast ? '10px' : '0px'};
  border-bottom-right-radius: ${props => props.isLast ? '10px' : '0px'};

  border-top: ${props => props.borderTop};
  border-left: ${props => props.borderSides};
  border-right: ${props => props.borderSides};
  border-bottom: ${props => props.borderBottom};

  background-color: ${props => props.backgroundColor};

  transition: all 0.3s ease-in-out;
`;

const TitleTextWrapper = styled.div`
  display: flex;

  flex-wrap: wrap;

  margin: 0 0 0 0;
  padding: 20px 10px;

  min-width: 148px;
  max-width: 148px;
`;

const HistoryTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
  
  margin: 0 0 0 0;
  padding: 20px 10px;

  width: 100%;
`;

const DivisionLine = styled.div`
  display: flex;

  min-width: 1px;
  max-width: 1px;
  height: 100%;

  background-color: #969696;
`;

//######################
//###### Button ########
//######################

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 180px;
  height: 98%;

  :hover {
    cursor: pointer;
  }
`;

const EditButton = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 90px;
  height: 98%;

  transition: all 0.3s ease-in-out;

  &:hover span {
    color: #6DD49F;
  }
`;

const DeleteButton = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 90px;
  height: 98%;

  transition: all 0.3s ease-in-out;

  &:hover span {
    color: #FF3131;
  }
`;

//####################
//###### TEXT ########
//####################

const TextWrapper = styled.div`
  //display: flex;
  //flex-direction: row;

  //justify-content: flex-start;
  //align-items: flex-start;
`;

const Text = styled.span`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  transition: all 0.3s ease-in-out;
  
  :hover {
    cursor: ${props => props.hover};
  }

  white-space: pre-wrap;
`;
